import React, { useState, useRef, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import "./BatchTable.scss";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import { useSelector } from "react-redux";
import { deleteBatch, getBatchUploadFiles } from "../../util/API/batch";
import Trash from "../../images/trash.svg";
import Edit from "../../images/edit-2.svg";
import PinPad from "../PinPad/PinPad";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import BatchViewModal from "../BatchViewModal/BatchViewModal";
import { Box } from "@mui/material";
import { ListTransFileRecs } from "../../util/API/batch";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

const PAYROLL_CATEGORY_ID = "33";

const getStatusConfig = (code) => {
  const map = {
    "3": { label: "Completed", color: "#d4edda", text: "#155724" },
    "1": { label: "Approved for processing", color: "#d1ecf1", text: "#0c5460" },
    "0": { label: "Approved for processing", color: "#d1ecf1", text: "#0c5460" },
    "-1": { label: "Review", color: "#fff3cd", text: "#856404" },
    "-2": { label: "Open", color: "#e2e3e5", text: "#383d41" },
    "2": { label: "Error", color: "#f5c6cb", text: "#721c24" },
    "5": { label: "Rejected", color: "#f8d7da", text: "#721c24" },
    "4": { label: "Cancelled", color: "#d6d8db", text: "#495057" },
  };
  return map[code] || { label: "Unknown", color: "#f8f9fa", text: "#333" };
};
const CODE_TO_STATUS = {
  "-2": "Open",
  "-1": "Needs Review",
  "1": "Approved for Processing",
  "0": "Approved for Processing",
  "2": "Error",
  "3": "Completed",
  "4": "Cancelled",
  "5": "Rejected",
};

export default function BatchTable({ history, refreshHistoryList, getHistoryList }) {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [showPinPad, setShowPinPad] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
    header: "",
  });
  const [selectedBatch, setSelectedBatch] = useState(null);

  // New state for total amounts
  const [batchTotals, setBatchTotals] = useState({});

  let configVariables = useSelector((state) => state.config.baseConfig);
  const BASE_FILE_URL = configVariables.BATCH_BASE_FILE_URL;
  console.log("BASE_FILE_URL---------",BASE_FILE_URL);

  const pageCount = Math.ceil(history.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const merchantInfo = useSelector((state) => state.login.user);

  const batchStatus = {
    0: "Scheduled",
    1: "In Progress",
    2: "Error",
    3: "Success",
    4: "Cancelled",
  };

  // Preload totals for all payroll batches (mimics the logic from handleDownload)
  

  

  const deleteRequest = async (batchId, pin) => {
    try {
      const response = await deleteBatch(merchantInfo.id, batchId, pin);
      if (response?.callStatus === "1") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Batch Upload " + batchId + " was deleted successfully",
          header: "Success!",
        });
        refreshHistoryList();
      } else {
        console.log(response);
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Batch Upload " + batchId + " was not deleted successfully",
          header: "Error!",
        });
      }
    } catch (error) {
      console.error("Error deleting batch:", error);
    }
  };

  const handleDeleteClick = (batchId) => {
    setSelectedBatchId(batchId);
    setShowPinPad(true);
  };

  const handleConfirm = (event, pin) => {
    if (selectedBatchId) {
      deleteRequest(selectedBatchId, pin.join(""));
    }
    setShowPinPad(false);
    setSelectedBatchId(null);
  };

  // Helper to set filename with _success or _err for payroll files
  const getPayrollFileName = (inputFilename, statusCode) => {
    const baseName = cleanFileName(inputFilename || "batch").replace(/\.csv$/i, "");
    const code = String(statusCode || "");

    let suffix = "";
    if (code === "3") suffix = "_success";
    else if (code === "2") suffix = "_err";

    return `${baseName}_records${suffix}.csv`;
  };

  const handleDownload = async (rowData) => {
  const categoryid = rowData?.Scheduleinstance?.categoryid;
  const requestid = rowData?.Scheduleinstance?.requestid;
  const inputFilename = rowData?.Scheduleinstance?.inputfilename || "batch";
  const outputFilename = rowData?.Scheduleinstance?.outputfilename;

  if (categoryid == PAYROLL_CATEGORY_ID) {
    try {
      const res = await ListTransFileRecs(requestid);

      if (res.callStatus !== "1") {
        setAlert({
          showAlert: true,
          severity: "error",
          header: "Download Failed",
          message: res.payload?.msg || "Failed to load records from server."
        });
        return;
      }

      const rawArray = res.payload?.record || [];
      const recordsArray = Array.isArray(rawArray) ? rawArray : rawArray ? [rawArray] : [];
      const allRecords = recordsArray.map(item => item.Transfilerecs).filter(Boolean);

      if (allRecords.length === 0) {
        setAlert({
          showAlert: true,
          severity: "info",
          header: "No Data",
          message: "No records available to download."
        });
        return;
      }

      // === Status & Total Calculation (Multi-currency) ===
      const statusCode = rowData.Scheduleinstance.executionstatus;
      const statusLabel = getStatusConfig(String(statusCode)).label;

      const downloadFilename = getPayrollFileName(inputFilename, statusCode);

      // Calculate totals by currency
      const totalsByCurrency = {};

      allRecords.forEach((r) => {
        const amount = parseFloat(r.amount || 0);
        const currency = (r.currency || "CAD").toUpperCase();
        //const identifier = r.phoneno ? r.phoneno : r.email;

        if (!totalsByCurrency[currency]) totalsByCurrency[currency] = 0;
        totalsByCurrency[currency] += amount;
      });

      // Build single total message (only for Completed status)
      let totalMessage = "";
      if (String(statusCode) === "3") {
        const totalParts = Object.entries(totalsByCurrency).map(([curr, total]) => {
          const formatted = total.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return `${formatted} ${curr}`;
        });

        totalMessage = `Total amount ${totalParts.join(" + ")} successfully deposited.`;
      }
      // ===================================================

//       const headers = [
//   "First Name", "Last Name", "Email", "Phone", "Amount", "Currency",
//   "Address Line 1", "Address Line 2", "Country", "State", "Zip Code",
//   "Date of Birth", "Comment", "Purpose of Account",
//   "Account Add Success Message", "Fund Add Success Message"
// ];
const headers = [
  "First Name", "Last Name", "Email", "Phone", "Amount", "Currency",
  "Address Line 1", "Address Line 2", "Country", "State", "Zip Code",
  "Date of Birth", "Comment", "Purpose of Account",
  "Status",          // ← add
  "Error Message",   // ← add
  "Account Add Success Message", "Fund Add Success Message"
];
      const rows = allRecords.map((r) => {
  const recordAmount = parseFloat(r.amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const recordCurrency = (r.currency || "CAD").toUpperCase();
  const recipientName = `${r.firstname || ""} ${r.lastname || ""}`.trim() || "Recipient";


  const identifier = r.phoneno ? r.phoneno : r.email;

  const accountMessage = r.usercreated === "0"
  ? `${identifier}@4pay.ph user already exists`
  : r.usercreated === "1"
  ? `${identifier} user created successfully`
  : "";

  return [
    decodeHtmlEntities(r.firstname || "").replace(/"/g, '""'),
    decodeHtmlEntities(r.lastname || "").replace(/"/g, '""'),
    (r.email || "").replace(/"/g, '""'),
    (r.phoneno || "").replace(/"/g, '""'),
    r.amount || "0.00",
    r.currency || "",
    (r.address1 || "").replace(/"/g, '""'),
    (r.address2 || "").replace(/"/g, '""'),
    r.country || "",
    r.state || "",
    r.zipcode || "",
    r.birthdate || "",
    (r.comment ? cleanNotes(r.comment) : "").replace(/"/g, '""'),
    (r.purposeofaccount || "").replace(/"/g, '""'),
    (CODE_TO_STATUS[String(r.status)] || r.status || ""), //added
    (r.errormessage || ""), // added
    accountMessage.replace(/"/g, '""'),
    (r.msg || "").replace(/"/g, '""')
  ];
});

      const csv = [headers.join(","), ...rows.map(row => row.map(cell => `"${cell}"`).join(","))].join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", downloadFilename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 40000);

      setAlert({
        showAlert: true,
        severity: "success",
        header: "Download Started",
        message: "CSV file is being downloaded."
      });
    } catch (err) {
      console.error("Download failed:", err);
      setAlert({
        showAlert: true,
        severity: "error",
        header: "Download Failed",
        message: "Error generating or saving CSV file. Please try again."
      });
    }
  } else {
    // Non-payroll download logic (unchanged)
    const filename = outputFilename || inputFilename;
    if (!requestid || !filename) {
      console.log("Missing requestid or filename");
      return;
    }

    try {
      const response = await getBatchUploadFiles(requestid);

      if (response?.data?.body?.path) {
        const fileUrl = `${BASE_FILE_URL}${response.data.body.path}`;
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = filename;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Download failed:", error);
      setAlert({
        showAlert: true,
        severity: "error",
        header: "Download Failed",
        message: "Error downloading file. Please try again."
      });
    }
  }
};

  const handleCloseModal = () => {
    setOpen(false);
  }

  const handleOpenModal = (row) => {
    setOpen(true);
    setSelectedBatch(row)
    console.log("row-------------",row);
  }

  const cleanNotes = (notes) =>
  notes
    ? notes
        
        .replace(/&amp;amp;/g, "&")
        .replace(/&amp;#039;/g, "'")
        .replace(/&amp;#39;/g, "'")
        
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&nbsp;/g, " ")
        .split("\n")
        .filter(Boolean)
        .join(" • ")
    : "—";
const cleanFileName = (fileName) => {
  if (!fileName) return "—";

  return fileName
    .replace(/BATCH_-/i, "BATCH-")
    .replace(/&amp;#039;/g, "'")
    .replace(/&#039;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&")
    .replace(/&/g, "_and_")
    .replace(/[()]/g, "")
    .replace(/[^a-zA-Z0-9\s'_.-]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    // Restore apostrophe: word ending in _s followed by _ or end
    .replace(/([a-zA-Z])_s(?=_|$)/g, "$1's")
    .trim();
};
  return (
    <TableContainer
      component={Paper}
      sx={{ boxShadow: "none", overflowX: "auto" }}
    >
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
        {/* Table Head */}
        <TableHead>
          <TableRow>
            <TableCell style={{ width: 100 }} className="batch-table-headers">
              Batch Id
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 180 }}
              className="batch-table-headers"
            >
              Request Date
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 300 }}
              className="batch-table-headers"
            >
              Input File
            </TableCell>

            {/* New Total Amount Column */}
            <TableCell
              align="right"
              style={{ width: 180 }}
              className="batch-table-headers"
            >
              Total Amount
            </TableCell>

            <TableCell
              align="left"
              style={{ width: 160 }}
              className="batch-table-headers"
            >
              Status
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 180 }}
              className="batch-table-headers"
            >
              Scheduled Date
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 160 }}
              className="batch-table-headers"
            >
              Comments
            </TableCell>
            <TableCell
              align="left"
              style={{ width: 180 }}
              className="batch-table-headers"
            >
              Downloads
            </TableCell>
            <TableCell
              align="right"
              style={{ width: 120 }}
              className="batch-table-headers"
            >
              Action
            </TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {history
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <TableRow key={row.Scheduleinstance?.requestid || "test" }>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ width: 100 }}
                  className="batch-row-text"
                >
                  {row.Scheduleinstance.requestid}
                </TableCell>
                <TableCell
                  style={{ width: 180 }}
                  align="left"
                  className="batch-row-text"
                >
                  {row.Scheduleinstance.requesttime}
                </TableCell>
                <TableCell
                  style={{ width: 300 }}
                  align="left"
                  className="batch-row-text"
                >
                  <span>{cleanFileName(row.Scheduleinstance.inputfilename)}</span>
                </TableCell>

                {/* Total Amount Cell */}
                <TableCell
  align="right"
  style={{ width: 180, fontWeight: 500, color: "#1976d2" }}
  className="batch-row-text"
>
  {row.Scheduleinstance.categoryid == PAYROLL_CATEGORY_ID
    ? (parseFloat(row.Scheduleinstance.amount) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      })
    : (parseFloat(row.Scheduleinstance.amount) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      }) }
</TableCell>

                <TableCell
                  style={{ width: 160 }}
                  align="left"
                  className="batch-row-text"
                >
  {
    (() => {
      const statusCode = row.Scheduleinstance.executionstatus;
      const categoryid = row.Scheduleinstance.categoryid;
      let statusLabel = batchStatus[statusCode] || `Unknown (${statusCode})`;
      let statusColor = 
        statusCode === 1 || statusCode === 0 ? "#FAC800" :
        statusCode === 3 ? "#3BC97B" :
        (statusCode === 2 || statusCode === 4) ? "#DC3545" : "inherit";

      if (categoryid == PAYROLL_CATEGORY_ID) {
        const config = getStatusConfig(statusCode.toString());
        statusLabel = config.label;
        statusColor = config.text;
      }

      return (
        <span
          style={{
            color: statusColor,
            fontFamily: "Nunito",
            fontSize: "15px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "33.6px",
          }}
        >
          {statusLabel}
        </span>
      );
    })()
  }
                </TableCell>
                <TableCell
                  style={{ width: 160 }}
                  align="left"
                  className="batch-row-text"
                >
                  {row.Scheduleinstance.scheduletime}
                </TableCell>
                <TableCell
                  style={{ width: 160 }}
                  align="left"
                  className="batch-row-text"
                >
                  {cleanNotes(row.Scheduleinstance.notes)}
                </TableCell>
                {/* <TableCell style={{ width: 160 }} align="left" className="batch-row-text">
  {
    (() => {
      const categoryid = row.Scheduleinstance.categoryid;
      const outputFilename = row.Scheduleinstance.outputfilename;
      const inputFilename = row.Scheduleinstance.inputfilename;
      const hasFile = outputFilename || inputFilename;

      if (categoryid == PAYROLL_CATEGORY_ID) {
        return (
          <span
            onClick={() => handleDownload(row)}
            className="download-link pointer"
            style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline", fontWeight: "bold" }}
          >
            {getPayrollFileName(inputFilename, row.Scheduleinstance.executionstatus)}
          </span>
        );
      } else {
        if (hasFile) {
          return (
            <span
              onClick={() => handleDownload(row)}
              className="download-link pointer"
              style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline", fontWeight: "bold" }}
            >
              {cleanFileName(outputFilename) || cleanFileName(inputFilename)}
            </span>
          );
        } else {
          return <span style={{ color: "#888" }}>Processing...</span>;
        }
      }
    })()
  }
</TableCell> */}
<TableCell style={{ width: 160 }} align="left" className="batch-row-text">
  {
    (() => {
      const categoryid = row.Scheduleinstance.categoryid;
      const outputFilename = row.Scheduleinstance.outputfilename;
      const inputFilename = row.Scheduleinstance.inputfilename;
      const statusCode = String(row.Scheduleinstance.executionstatus);
      const hasFile = outputFilename || inputFilename;
      const isDownloadable = statusCode === "2" || statusCode === "3"; // Error or Completed

      if (categoryid == PAYROLL_CATEGORY_ID) {
        if (isDownloadable) {
          return (
            <span
              onClick={() => handleDownload(row)}
              className="download-link pointer"
              style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline", fontWeight: "bold" }}
            >
              {getPayrollFileName(inputFilename, row.Scheduleinstance.executionstatus)}
            </span>
          );
        } else {
          return <span style={{ color: "#888" }}>Processing...</span>; // or return null to show nothing
        }
      } else {
        if (hasFile) {
          return (
            <span
              onClick={() => handleDownload(row)}
              className="download-link pointer"
              style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline", fontWeight: "bold" }}
            >
              {cleanFileName(outputFilename) || cleanFileName(inputFilename)}
            </span>
          );
        } else {
          return <span style={{ color: "#888" }}>Processing...</span>;
        }
      }
    })()
  }
</TableCell>
                <TableCell
                  style={{ width: 120 }}
                  align="right"
                  className="delete-row-text"
                >
                  <Box sx={{ display:"flex", justifyContent:"flex-end", gap:3 }}>
                    <div className="delete-container">
                      <img
                        className="pointer"
                        src={Trash}
                        onClick={() =>
                          handleDeleteClick(row.Scheduleinstance.requestid)
                        }
                        alt="Delete"
                      />
                    </div>

                    {/* Edit icon — only show when NOT payroll */}
    {row.Scheduleinstance.categoryid !== PAYROLL_CATEGORY_ID && (
      <div className="delete-container">
        <img
          className="pointer"
          src={Edit}
          onClick={() => handleOpenModal(row.Scheduleinstance)}
          alt="Edit"
        />
      </div>
    )}

                  </Box>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      <div className="pagination-styling-batch">
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </div>

      {showPinPad && (
        <PinPad
          show={showPinPad}
          handleConfirm={handleConfirm}
          onClick={() => setShowPinPad(false)}
        />
      )}
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prev) => {
          setAlert({ ...prev, showAlert: false });
          refreshHistoryList();
        }}
        autoclose={alert.severity === "error" ? false : true}
      />

      <BatchViewModal 
        open={open}
        closeModal={handleCloseModal}
        selectedBatch={selectedBatch}
        getHistoryList={getHistoryList}
      />
    </TableContainer>
  );
}
